config.$inject = ["$locationProvider", "$animateProvider", "$urlMatcherFactoryProvider", "cfpLoadingBarProvider"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}applyQueryParamsToLocalStorage();
var API_URL = localStorage.getItem('API_URL');
if (API_URL) window.gplansConf.API_URL = API_URL;

window.gplansConf = window.gplansConf || {};
window.gplansConf.APP_BASE_URL = window.gplansConf.APP_BASE_URL || process.env.APP_BASE_URL;
window.gplansConf.API_URL = window.gplansConf.API_URL || process.env.API_URL;
window.gplansConf.STRIPE_KEY = window.gplansConf.STRIPE_KEY || process.env.STRIPE_KEY;
window.gplansConf.defaultPlan = window.gplansConf.defaultPlan || process.env.DEFAULT_PLAN;
window.gplansConf.ravenDSN = window.gplansConf.ravenDSN || process.env.RAVEN_DSN;
window.gplansConf.FBAppId = window.gplansConf.FBAppId || process.env.FB_APP_ID;
window.gplansConf.SIFT_SCIENCE_ACCOUNT = window.gplansConf.SIFT_SCIENCE_ACCOUNT || process.env.SIFT_SCIENCE_ACCOUNT;

export var gplansConfigModule = angular.
module('gplans.config', [
  // 'angular-loading-bar',
  // 'angular-tour',
  // 'angulartics',
  // 'chart.js'
]).
constant('gplansConf', {
  APP_BASE_URL: window.gplansConf.APP_BASE_URL,
  API_URL: window.gplansConf.API_URL,
  STRIPE_KEY: window.gplansConf.STRIPE_KEY,
  defaultPlan: window.gplansConf.defaultPlan }).

config(config);


/**
                 * @name config
                 * @desc Enable HTML5 routing
                 */
// function config($locationProvider, $animateProvider, $analyticsProvider, cfpLoadingBarProvider, tourConfig) {
function config(
$locationProvider,
$animateProvider,
$urlMatcherFactoryProvider,
cfpLoadingBarProvider)
{
  "ngInject";

  $urlMatcherFactoryProvider.strictMode(false);
  $locationProvider.html5Mode(true);

  // cfpLoadingBarProvider.spinnerTemplate = '';
  // tourConfig.margin = 3;

  // disable ng-animate-hide and other extra ng-animate classes for some cases/elements
  // it doesn't work well for every custom animations on platform
  // just add "ng-animate-disabled" class to such an element
  $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

  cfpLoadingBarProvider.includeSpinner = false;

  // we could use withBase here, but it ads an extra slash to url which we hate
  // $analyticsProvider.withAutoBase(true); <- we also hate this as it ads # urls and doesn't work with html5 mode
}

/**
   * @function param
   *
   * Takes a string of name value pairs and returns a Object literal that represents those params.
   * Takes an Object literal and returns a string of name value pairs that represents those params.
   *
   * @param {Object} A JavaScript Object that represents the params
   * @return {String} params a string like <code>"foo=bar&person[age]=3"</code>
   *
   */
function param(obj, prefix) {
  var arr = [],p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,v = obj[p];
      arr.push(v !== null && _typeof(v) === "object" ?
      param(v, k) :
      encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return arr.
  filter(function (s) {return !!s;}).
  join("&");
}

/**
   * @function deparam
   *
   * Takes a string of name value pairs and returns a Object literal that represents those params.
   *
   * @param {String} params a string like <code>"foo=bar&person[age]=3"</code>
   * @return {Object} A JavaScript Object that represents the params:
   *
   *     {
  			 *       foo: "bar",
  			 *       person: {
  			 *         age: "3"
  			 *       }
  			 *     }
   */
function deparam(params) {

  var digitTest = /^\d+$/,
  keyBreaker = /([^\[\]]+)|(\[\])/g,
  plus = /\+/g,
  paramTest = /([^?#]*)(#.*)?$/;

  if (!params || !paramTest.test(params)) {
    return {};
  }

  var data = {};
  var pairs = params.split('&') || [];
  var current;

  for (var i = 0; i < pairs.length; i++) {
    current = data;
    var pair = pairs[i].split('=');

    // if we find foo=1+1=2
    if (pair.length != 2) {
      pair = [pair[0], pair.slice(1).join("=")];
    }

    var key = decodeURIComponent(pair[0].replace(plus, " ")),
    value = decodeURIComponent(pair[1].replace(plus, " ")),
    parts = key.match(keyBreaker);

    for (var j = 0; j < parts.length - 1; j++) {
      var part = parts[j];
      if (!current[part]) {
        // if what we are pointing to looks like an array
        current[part] = digitTest.test(parts[j + 1]) || parts[j + 1] == "[]" ? [] : {};
      }
      current = current[part];
    }
    var lastPart = parts[parts.length - 1];
    if (lastPart == "[]") {
      current.push(value);
    } else {
      current[lastPart] = value;
    }
  }
  return data;
}

/**
   * Parse some query params and apply to app.
   *
   * API_URL: set something to set it to localStorage and use in app
   *          set 'null' to clear it from localstorage
   */
function applyQueryParamsToLocalStorage() {
  var parsedQuery = deparam(window.location.search.substring(1));

  if (typeof parsedQuery.API_URL !== 'undefined') {
    var parsedQueryCopy = Object.assign({}, parsedQuery);
    switch (parsedQuery.API_URL) {
      case "null":
        localStorage.removeItem('API_URL');
        break;
      default:
        localStorage.setItem('API_URL', parsedQueryCopy.API_URL);}


    delete parsedQueryCopy.API_URL;
    var l = window.location;
    var newUrl = "".concat(l.protocol, "//").concat(l.hostname).concat(l.port ? ":".concat(l.port) : '').concat(l.pathname, "?").concat(param(parsedQueryCopy));
    history.replaceState(null, null, newUrl);
  }
}